import { environment_conf } from "../environment";

export const CREDIT_EXCEED_ERROR_CODE_ERROR_MESSAGE = `You have reached your credit limit, please top up credits in ${environment_conf.base_app_domain} to continue.`;